var render = function render(){var _vm=this,_c=_vm._self._c;return (this.isSuper())?_c('div',[_c('el-button',{attrs:{"icon":"fa fa-trash-alt","size":"small","type":"danger","circle":""},on:{"click":function($event){return _vm.deleteEntry()}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }